export default __webpack_public_path__ + "static/media/bg.1fec6be6.webp";